import clsx from 'clsx';
import { useMemo } from 'react';

import globalStyle from '@vestico/shared/src/layouts/utils.module.css';

import { CustomCSSProperties } from '../model';
import { Button } from './Button';
import style from './buttonsRow.module.css';

export enum ButtonStyle {
  default = 0,
  back,
}

export interface ButtonDefinition {
  title: string;
  disabled?: boolean;
  loading?: boolean;
  vertical?: boolean;
  style: ButtonStyle;
  onClick: () => void;
  action?: () => void;
}

export interface ButtonsRowProps {
  leftButton?: ButtonDefinition;
  rightButton?: ButtonDefinition;
  centerText?: string;
  backgroundColor?: string;
  vertical?: boolean;
}

const createButtonMarkup = (buttonDefinition?: ButtonDefinition, vertical?: boolean) => {
  if (!buttonDefinition) {
    return <div className={clsx(style.placeholder, { [style.vertical]: vertical })} />;
  }
  const { title, onClick, disabled, style: buttonStyle, loading } = buttonDefinition;

  const isBackButton = buttonStyle === ButtonStyle.back;
  return <Button content={title} onClick={onClick} disabled={disabled} plain={vertical && isBackButton} outline={isBackButton} loading={loading} />;
};

export const ButtonsRow = ({ leftButton, rightButton, centerText, backgroundColor, vertical }: ButtonsRowProps) => {
  const leftButtonMarkup = createButtonMarkup(leftButton, vertical);
  const rightButtonMarkup = createButtonMarkup(rightButton, vertical);
  const centerMarkup = centerText ? <div className={clsx(style.center, globalStyle.textSmall)}>{centerText}</div> : <div />;

  const customCSS = useMemo(() => {
    if (!backgroundColor) {
      return undefined;
    }
    const css: CustomCSSProperties = { backgroundColor };
    return css;
  }, [backgroundColor]);

  if (vertical) {
    return (
      <div className={clsx(style.root, { [style.vertical]: vertical })} style={customCSS}>
        {rightButtonMarkup}
        {leftButtonMarkup}
        {centerText ? centerMarkup : null}
      </div>
    );
  }
  return (
    <div className={clsx(style.root, { [style.vertical]: vertical })} style={customCSS}>
      {leftButtonMarkup}
      {centerMarkup}
      {rightButtonMarkup}
    </div>
  );
};

export default ButtonsRow;
